
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-d3f77a06\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?{\"import\":[\"C:\\\\Users\\\\NeferUser\\\\Desktop\\\\www\\\\site_config\\\\veniceman\\\\styl\\\\variables.styl\"],\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./footer.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./footer.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d3f77a06\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./footer.vue"),
  /* scopeId */
  "data-v-d3f77a06",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/different/taiyangcheng018/footer/footer.vue
// module id = 600
// module chunks = 31